export default "__VITE_ASSET__Bp49MXDl__"